import api from './client';

export const getAuditLogs = (params?: any) => api.get('/audit/logs/', { params });
